module.exports = __webpack_public_path__ + "static/media/30OIOS4.62fb442e.jpg";